var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_67203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "url(#paint0_radial_200_67203)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_200_67203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2845 5.75277C10.1698 5.86805 10.0856 6.00824 10.0371 6.1607L6.92945 14.4384H5.67603V15.708H8.04987L8.96463 13.1833L9.39996 11.9141L10.9825 7.41998L13.9011 15.708H16.3235V14.4384H15.0652L11.9578 6.16043C11.9093 6.00811 11.8251 5.86797 11.7104 5.75277C11.5214 5.56274 11.2649 5.45599 10.9975 5.45599C10.7301 5.45599 10.4737 5.56274 10.2845 5.75277Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_200_67203",
    x: 1.67603,
    y: 5.45599,
    width: 18.6475,
    height: 18.252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_200_67203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_200_67203",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_200_67203",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45) scale(31.1127 20.9194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244792,
    stopColor: "#D5B78B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875C3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_67203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLshare);
export default __webpack_public_path__ + "static/media/lshare.a1d018e64b7e4193ce69c0e3c696415e.svg";
export { ForwardRef as ReactComponent };